import { render, staticRenderFns } from "./palletinfolisting.vue?vue&type=template&id=6f06c5ae&"
import script from "./palletinfolisting.vue?vue&type=script&lang=js&"
export * from "./palletinfolisting.vue?vue&type=script&lang=js&"
import style0 from "./palletinfolisting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports